/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAuthTokenResponse
 */
export interface OutputAuthTokenResponse {
    /**
     * Користувач заблокований (токен не видається)
     * @type {boolean}
     * @memberof OutputAuthTokenResponse
     */
    blocked?: boolean;
    /**
     * i18n ключ для повідомлення про блокування (залежить від ролі користувача)
     * @type {string}
     * @memberof OutputAuthTokenResponse
     */
    blockedMessageKey?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAuthTokenResponse
     */
    challenge?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputAuthTokenResponse
     */
    hasTotp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OutputAuthTokenResponse
     */
    hasWebAuthn?: boolean;
    /**
     * Вимога 2FA верифікації
     * @type {boolean}
     * @memberof OutputAuthTokenResponse
     */
    requires2FA?: boolean;
    /**
     * Успішна авторизація (токен встановлюється в cookie)
     * @type {boolean}
     * @memberof OutputAuthTokenResponse
     */
    success?: boolean;
}

/**
 * Check if a given object implements the OutputAuthTokenResponse interface.
 */
export function instanceOfOutputAuthTokenResponse(value: object): boolean {
    return true;
}

export function OutputAuthTokenResponseFromJSON(json: any): OutputAuthTokenResponse {
    return OutputAuthTokenResponseFromJSONTyped(json, false);
}

export function OutputAuthTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAuthTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'blocked': json['blocked'] == null ? undefined : json['blocked'],
        'blockedMessageKey': json['blockedMessageKey'] == null ? undefined : json['blockedMessageKey'],
        'challenge': json['challenge'] == null ? undefined : json['challenge'],
        'hasTotp': json['hasTotp'] == null ? undefined : json['hasTotp'],
        'hasWebAuthn': json['hasWebAuthn'] == null ? undefined : json['hasWebAuthn'],
        'requires2FA': json['requires2FA'] == null ? undefined : json['requires2FA'],
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function OutputAuthTokenResponseToJSON(value?: OutputAuthTokenResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'blocked': value['blocked'],
        'blockedMessageKey': value['blockedMessageKey'],
        'challenge': value['challenge'],
        'hasTotp': value['hasTotp'],
        'hasWebAuthn': value['hasWebAuthn'],
        'requires2FA': value['requires2FA'],
        'success': value['success'],
    };
}

